import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { resetAuthState } from "../state/auth/authSlice";
import { routes } from "../utils";

export default function LogOutConfirm() {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleLogout = async () => {
		dispatch(resetAuthState());
		// setTimeout(() => {
		navigate(routes.LOGIN);
		// }, 2000);
	};

	useEffect(() => {
		handleLogout();
	}, []);

	return null;
}
